<template>
  <!-- prettier-ignore -->
  <div
    class="Badge"
  >
    <div class="badge-content">
      <div
        v-if="hasBadgeTitle"
        class="title"
        v-text="badgeTitle"
      />
      <div
        class="content"
        v-html="content"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import usePartnerWidget from '@/hooks/usePartnerWidget'

// Hooks
const { getLabel, hasLabel } = usePartnerWidget()

// Computed
const badgeTitle = computed(() => {
  return getLabel('entry_badge_title')
})

const content = computed(() => {
  return getLabel('entry_badge')
})

const hasBadgeTitle = computed(() => {
  return !!hasLabel('entry_badge_title')
})
</script>

<style scoped>
.Badge {
  display: inline-block;
  align-items: center;
  background-color: #e9333a;
  word-break: break-word;
  color: var(--c-white);
  border-radius: 50%;
  width: var(--pw-badge-size);
  height: var(--pw-badge-size);
  font-family: 'Open Sans', sans-serif;
  padding: 15px;

  .title {
    display: inline-block;
    font-weight: bold;
  }

  .badge-content {
    display: flex;
    height: 100%;
    padding: 10px;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    font-weight: normal;
    font-size: var(--pw-font-size-small);
    line-height: var(--pw-line-height-small);
  }

  .wide & {
    height: 190px;
    width: 190px;

    .badge-content {
      font-size: 20px;
      line-height: 25px;
    }
  }

  @media screen (max-width: 299px) {
    .badge-content {
      font-size: 10px;
      line-height: 12px;
    }
  }
}
</style>
